export default {
  path: 'price',
  name: 'subscription/price',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-price" */ './Price')
}
